import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 选择联系人
export function chooseContact(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.CHOOSE_CONTACT, option);
}
